export default "__VITE_ASSET__BJtLh7zr__"